import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import {
  combineValidators,
  isRequired,
  composeValidators,
  matchesPattern,
} from "revalidate";
import { RootStoreContext } from "../../../app/stores/rootStore";
import TextInput from "../../../app/common/form/TextInput";

const validate = combineValidators({
  testSetId: composeValidators(
    isRequired({ message: "Campo obligatorio" }),
    matchesPattern(/^[0-9a-fA-F]{8}[-]([0-9a-fA-F]{4}[-]){3}[0-9a-fA-F]{12}$/)({
      message: "Formato esperado: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    })
  )(),
});

const documentsId = {
  InvoiceSale: 1,
  SupportDocument: 5,
  EquivalentDocumentSPD: 60,
};

const IdDocumentConfiguration = ({ activeDocumentState, activeDocument }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { addTestSetDocument, loadingAddTestSetDocument } = rootStore.companyStore;

  const [testDianForm, setTestDianForm] = useState({
    testSetId: activeDocumentState?.id,
  });

  if (testDianForm.testSetId !== activeDocumentState?.id) {
    setTestDianForm({ testSetId: activeDocumentState?.id });
  }

  const hasTestSetIdDisabled = !!activeDocumentState?.id;

  const handleFinalFormSubmit = (values: any) => {
    const body = {
      testSetId: values.testSetId,
      documentType: documentsId[activeDocument],
    };

    addTestSetDocument(body);
  };

  return (
    <div>
      <FinalForm
        validate={validate}
        initialValues={testDianForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, values, invalid }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Ingrese el identificador del conjunto de pruebas</label>
              <Field
                name="testSetId"
                component={TextInput}
                defaultValue={values.testSetId}
                disabled={hasTestSetIdDisabled}
              />
              <Button
                className="ui primary button"
                color="blue"
                type="submit"
                icon="send"
                content="Enviar set de pruebas"
                disabled={invalid || hasTestSetIdDisabled || values.testSetId === '' || loadingAddTestSetDocument}
                loading={loadingAddTestSetDocument}
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(IdDocumentConfiguration);
